import React from 'react';
import {
  bool, node, number, oneOfType, string,
} from 'prop-types';
import { Paragraph } from 'components/common';
import './SummaryCard.scss';
import classNames from 'classnames';

const SummaryCard = ({
  slug,
  title,
  value,
  primary,
  secondary,
  tertiary,
  danger,
  warning,
  columnLabel = 5,
  columnValue = 7,
  highlightTitle,
  highlightValue,
  valueRight,
  className,
  dataSelectorId,
  showAsColumns,
}) => {
  const sharedClasses = {
    primary,
    secondary,
    tertiary,
    danger,
    warning,
  };

  return (
    <div className={classNames(
      `${showAsColumns ? 'layout-column summary-column' : 'layout-row summary-row'}`, {
        [className]: className && className.length > 0,
      }
    )}
    >
      {title && (
        <div
          className={classNames(
            'summary-title',
            `${highlightTitle ? 'title-wrapper' : ''}`,
            `${showAsColumns ? 'layout-row' : `layout-column column-xs-${columnLabel}`}`,
          )}
          data-selector={`${dataSelectorId}-title${(slug ? `:${slug}` : '')}`}
        >
          <Paragraph><strong>{title}</strong></Paragraph>
        </div>
      )}
      <div
        className={classNames(
          'summary-value',
          `${showAsColumns ? 'layout-row' : 'layout-column'}`, {
            [`column-xs-${columnValue}`]: !!title && !showAsColumns,
            'column-xs-12': !title && !showAsColumns,
            'text-right-wrapper': valueRight,
            'title-wrapper': highlightValue,
            ...sharedClasses,
          }
        )}
        data-selector={`${dataSelectorId}-value${(slug ? `:${slug}` : '')}`}
      >
        <Paragraph>{value}</Paragraph>
      </div>
    </div>
  );
};

SummaryCard.defaultProps = {
  highlightTitle: false,
  highlightValue: false,
  valueRight: false,
  columnLabel: 5,
  columnValue: 7,
  className: null,
  dataSelectorId: 'summaryCard',
  showAsColumns: false,
};

SummaryCard.propTypes = {
  slug: string,
  title: string.isRequired,
  value: oneOfType([string, number, node]).isRequired,
  primary: bool,
  secondary: bool,
  tertiary: bool,
  danger: bool,
  warning: bool,
  columnLabel: number,
  columnValue: number,
  highlightTitle: bool,
  highlightValue: bool,
  valueRight: bool,
  className: string,
  dataSelectorId: string,
  showAsColumns: bool,
};

export default SummaryCard;
